<div class="business-selection-container">
  <div class="welcome-message">
    <h1 class="greeting">Hi </h1>
    <div class="user-info">
      <p class="email">{{ _credentials?.email }}</p>
      <a href="#" class="logout-link" (click)="redirectToLogin()">Logout</a>
    </div>
  </div>
  <g99-card
    variant="borderless"
    backgroundColor="#F3F5F9"
    pt="24px"
    pr="24px"
    pb="24px"
    pl="24px"
  >
    <div class="organization-selector">
      <!-- SKELETON LOADER BLOCK -->
      <ng-container *ngIf="isLoading; else businessList">
        <div class="skeleton-wrapper">
          @for (s of [1, 2, 3, 4]; track s) {
            <div class="skeleton-item"></div>
          }
        </div>
      </ng-container>

      <!-- BUSINESS LIST WHEN LOADED -->
      <ng-template #businessList>
        <p class="select-org-text">Select Business</p>
        <div class="org-list">
          @for (item of businesses; let i = $index; track $index) {
            <div class="business-btn">
              <g99-button
                variant="medium"
                iconPosition="right"
                width="100%"
                className="text-align-left"
                borderRadius="10px"
                iconColor="#799F92"
                [color]="'white'"
                [svgIcon]="svgIcon"
                [disabled]="
                  isLoading || (selectedIndex !== null && selectedIndex !== i)
                "
                [isShowIconLoader]="selectedIndex === i && businessLoader"
                (buttonClick)="selectBusiness(item, i)"
              >
                {{ item.name }}
              </g99-button>
            </div>
          }
        </div>
      </ng-template>
    </div>
  </g99-card>
</div>
